import { FC } from 'react'
import { colors } from '@chegg-ui/theme'
import { AIStarIcon } from '../ProofReaderLeftPanel/AIStarIcon'
import { AIPoweredBadgeContainer } from './styled'

export const AIPoweredBadge: FC = () => (
  <AIPoweredBadgeContainer>
    <AIStarIcon color={colors.violet700} size="x-small" />
    <span>AI-powered</span>
  </AIPoweredBadgeContainer>
)
